<template>
    <div class="navBar-box">
        <nav class="navbar container1 navbar-expand-lg navbar-light">
            <div class="left-box">
                <router-link class="navbar-brand" to="/cloudHome">
                    <div class="logo-box">
                        <img class="logo-icon" src="../assets/img/logo2.png" />
                    </div>
                </router-link>
            </div>
            <div class="navbar-btn-group">
                <div class="navbar-btn1" @click="visible = true">免费试用</div>
                <div class="navbar-btn2" @click="toSaas">登录使用</div>
            </div>
            <button
                class="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                <span class="iconfont icon-caidan"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <div></div>
                <div class="center-box">
                    <ul class="navbar-nav">
                        <li class="nav-item">
                            <router-link :class="path == '/cloudHome' ? 'nav-link active' : 'nav-link'" to="/cloudHome">首页</router-link>
                        </li>
                        <!-- <li class="nav-item"><router-link :class="path == '/cloudProduct' ? 'nav-link active' : 'nav-link'" to="/cloudProduct">产品</router-link></li> -->
                        <li class="nav-item">
                            <router-link :class="path == '/cloudSchemeDetails' ? 'nav-link active' : 'nav-link'" to="/cloudSchemeDetails">行业标杆案例</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :class="path == '/about' ? 'nav-link active' : 'nav-link'" to="/about">关于我们</router-link>
                        </li>
                        <li class="nav-item free-trial-btn" @click="visible = true">
                            <a class="nav-link">免费试用</a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
        <form-dialog v-if="visible" @close="visible = false"></form-dialog>
    </div>
</template>

<script>
import formDialog from './formDialog.vue';
export default {
    name: '',
    data() {
        return {
            path: '',
            visible: false //免费试用弹出窗
        };
    },
    created() {},
    mounted() {
        this.path = this.$route.path;
    },
    computed: {},
    methods: {
        toSaas() {
            // 跳转到saas登录页面
            window.location.href = 'https://saas.sscanmou.com/login';
        }
    },
    components: {
        formDialog
    },
    beforeDestroy() {},
    watch: {}
};
</script>

<style scoped lang="less">
@media @max-sm {
    .navBar-box {
        .navbar {
            width: 100% !important;
            padding: 0 10px !important;
            box-sizing: border-box;
            justify-content: space-between !important;
        }
    }
}
.navBar-box {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    position: fixed;
    top: 0;
    z-index: 90;
    background: #fff;
    .navbar {
        min-height: 79px;
        background: none;
        font-size: 15px;
        color: #333;
        justify-content: space-between;
        padding-left: 0;
        padding-right: 0;
        position: relative;
        .nav-link {
            color: #333;
            font-size: 16px;
            text-align: left;
            padding-left: 0;
            padding-right: 0;
        }

        .active {
            color: #ff5d00;
        }

        .left-box {
            // display: flex;
            // align-items: center;
            .navbar-brand {
                // line-height: 79px;
                padding-top: 0;
                padding-bottom: 0;
            }
            .logo-icon {
                width: auto;
                height: 38px;
                // margin-left: 15px;
                // object-fit: scale-down;
            }

            .logo {
                width: auto;
                height: 20px;
                // margin-left: 15px;
                object-fit: scale-down;
            }
        }
        .navbar-toggler {
            .icon-caidan {
                color: #000;
                font-size: 22px;
            }
        }
        .collapse {
            // width: ;
            // display: flex;
            justify-content: flex-start;
            // align-items: center;
            // flex-wrap: wrap;
        }
        .collapse:not(.show) {
            display: none;
        }
        .center-box {
            .nav-link {
                margin-right: 52px;
                .arrow-down {
                    font-size: 14px;
                    margin-left: 4px;
                }
            }
            .nav-item:last-child {
                .nav-link {
                    margin-right: 0px;
                }
            }
            .dropdown-toggle::after {
                display: none;
            }
            .free-trial-btn {
                cursor: pointer;
                display: none;
            }
        }

        .right-box {
            padding-right: 25px;
            display: flex;
            align-items: center;

            .query-icon {
                font-size: 24px;
                margin-right: 22px;
            }

            .el-dropdown-link {
                color: #333;
                display: flex;
                align-items: center;

                .text {
                    margin: 0 5px;
                }

                .el-icon-caret-bottom {
                    color: #888788;
                    font-size: 13px;
                }
            }
        }
        .navbar-btn-group {
            justify-content: flex-start;
            display: flex;
            align-items: center;
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            .navbar-btn1 {
                width: 130px;
                height: 45px;
                background: #ff5d00;
                border-radius: 23px;
                font-size: 20px;
                font-weight: 400;
                font-family: MiSans;
                color: #ffffff;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                user-select: none;
            }
            .navbar-btn2 {
                margin-left: 20px;
                width: 152px;
                height: 45px;
                border: 1px solid #ff5d00;
                border-radius: 23px;
                font-size: 20px;
                font-family: MiSans;
                font-weight: 400;
                color: #ff5e01;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                user-select: none;
            }
        }
    }
}
</style>
<style lang="less" scoped>
@media @min-sm {
    .navbar-expand-lg .navbar-collapse {
        margin-left: 48px;
    }
}
@media @max-sm {
    .navBar-box .navbar .navbar-btn-group {
        position: relative;
        transform: none;
        flex-grow: 1;
    }
    .navBar-box .navbar .left-box {
        height: 79px;
        line-height: 79px;
    }
}
@media screen and(max-width:568px) {
    .navBar-box .navbar .navbar-btn-group {
        display: none;
    }
    .navBar-box .navbar .navbar-collapse .center-box .navbar-nav .nav-item.free-trial-btn {
        display: block;
    }
}
</style>
